module.exports = __webpack_public_path__ + "static/img/12.3cf6cb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/zombs/12.png
// module id = rI63
// module chunks = 35